module.exports = __webpack_public_path__ + "media/images/sort_both-9a6486086d09bb38cf66a57cc559ade3.png";